<template>
	<div>
		<van-field :required="formCreateInject.rule.validate[0].required" :value="value"
			:label="formCreateInject.prop.title.title" placeholder="" @input="change" type="textarea"
			:readonly="disabled || readonly">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>

	</div>
</template>
<style scoped>

</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {

		},
		data() {
			return {
				ref: Math.random(),
				textareavalue: this.value
			}
		},
		created() {


		},
		mounted() {


		},
		watch: {
			value(e) {
				this.textareavalue = e
			}
		},
		computed: {

		},
		methods: {

		}
	}
</script>
